import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { PhoneSetup } from './components/PhoneSetup'
import { HdrTestScreen } from './components/HdrTestScreen'
import { TrailerOverlay } from './components/TrailerOverlay'
import { getConfig } from './lib/config'
import './styles.css'

const phoneSetup = new URLSearchParams(window.location.search).has('setup')
  || /^\/setup\/?$/.test(window.location.pathname)
// the hardware test routes exist unless the owner has switched diagnostics off
const diagnosticsAllowed = getConfig().features.hdrDiagnostics
const hdrTest = diagnosticsAllowed && (new URLSearchParams(window.location.search).has('hdr-test')
  || /^\/hdr-test\/?$/.test(window.location.pathname))
const trailerTest = new URLSearchParams(window.location.search).has('trailer-test')
  || /^\/trailer-test\/?$/.test(window.location.pathname)
document.documentElement.classList.toggle('phone-mode', phoneSetup)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {hdrTest ? <HdrTestScreen /> : trailerTest ? (
      <TrailerOverlay
        directUrl="./test-media/vela-big-buck-bunny-30s-multiaudio.mp4"
        title="Vela trailer hardware proof"
        onClose={() => window.history.back()}
      />
    ) : phoneSetup ? <PhoneSetup /> : <App />}
  </React.StrictMode>,
)
